import i18n from '../general/i18n';
import { CHECK_IN_MASTER_ROUTE, CHECK_IN_PARENT_ROUTE, DOSSIER_DETAIL_ROUTE } from '../general/router/constants';
import { allPermissions } from '../general/utils/authHelper';
import Permission from '../shared/constants/Permission';
import { chatLoader, checklistLoader, dossierLoader, dossierDetailLoader, checkInLoader } from './loaders';

const DossierPage = () => import('./views/DossierPage.vue');
const DossierDetailView = () => import('./views/DossierDetailView.vue');
const ChecklistView = () => import('../checklist/views/ChecklistView.vue');
const CheckInPage = () => import('./views/CheckInPage.vue');
const CheckInDetailView = () => import('@/dossier/views/CheckInDetailView.vue');

export default [
  {
    path: '/dossier/:dossierId',
    name: 'dossier-parent',
    component: DossierPage,
    props: {
      context: dossierLoader,
      chatContext: chatLoader,
    },
    meta: {
      hasAccess: allPermissions(Permission.ACCESS_TO_DOSSIERS),
      title({ context }) {
        return `${context.dossier.externalReference || i18n.global.t('dossierDetail.pageTitle')}`;
      },
      logicalModule: 'dossier-detail',
      logicalParents: ['status-board', 'tasks', 'planner', 'customer-satisfaction', 'work-preparations'],
    },
    children: [
      {
        path: '',
        name: DOSSIER_DETAIL_ROUTE,
        component: DossierDetailView,
        props: {
          context: dossierDetailLoader,
        },
      },
      {
        path: 'checklists/:checklistId',
        name: 'checklist-detail',
        component: ChecklistView,
        props: {
          context: dossierDetailLoader,
          checklist: checklistLoader,
        },
      },
    ],
  },
  {
    path: '/dossier/:dossierId/check-in',
    name: CHECK_IN_PARENT_ROUTE,
    component: CheckInPage,
    props: {
      context: checkInLoader,
    },
    meta: {
      hasAccess: allPermissions(Permission.ACCESS_TO_DOSSIERS),
      title: 'checkIn.title',
      showEmpty: true,
      logicalModule: 'dossier-detail',
    },
    children: [
      {
        path: '',
        name: CHECK_IN_MASTER_ROUTE,
        component: CheckInDetailView,
        props: {
          context: checkInLoader,
        },
      },
    ],
  },
];
